import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Project from "./Project";
import Particle from "../Particle";
import GamerGrove from "../../Assets/Project/GamerGrove.png";
import Netflix from "../../Assets/Project/Netflix Clone.png";
import Shopping from "../../Assets/Project/Shopping Bot.png";
import Portfolio from "../../Assets/Project/Portfolio.png";
// import bct from "../../Assets/Project/bct.png";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Most Recent <strong className="purple">Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
            I am Proud in the amount of success I've accomplished in such a short time
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <Project
            imgPath={Portfolio}
              isBlog={false}
              title="Personal-Portfolio"
              description="
              My portfolio website is used to showcase my skills using the React framework, as well as CSS components, to illustrate my journey."
            //   ghLink="https://github.com/ShivaniYadav07"
            //   demoLink="https://www.shivaniyadav.online/"
            />
          </Col>
          <Col md={4} className="project-card">
            <Project
               imgPath={GamerGrove}
              isBlog={false}
              title="GamerGrove"
              description="
              This awesome project was built with an amazing team of engineers, where we invested countless hours in implementing a game hub for gamers. Not only do users and guests have the capability to purchase games and search/filter through them, but upon signing up and signing in, you also have Pinterest-like features that enable you to create a board, wishlist, and more, features that a typical guest would not have access to."
            //   ghLink="https://github.com/ShivaniYadav07/NewsApp"
              // demoLink="https://editor.soumya-jit.tech/"
            />
          </Col>
          <Col md={4} className="project-card">
            <Project
            imgPath={Shopping}
              isBlog={false}
              title="Shopping Bot"
              description="I've always had an interest in automating the process of buying or gathering specific items or information. So, I built this bot using Python and Selenium to automate the seamless purchase of items, utilizing test data to acquire items that may be in scarce supply. I also added my code from my IDE (VS Code) to display what is going on "
            //   ghLink="https://github.com/ShivaniYadav07"
            //   demoLink="https://www.amaalagroup.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <Project
              imgPath={Netflix}
              isBlog={false}
              title="Netflix Clone"
              description="This Netflix clone was a testament not only to tagging along but also to understanding how things work and becoming comfortable using third-party APIs and experimenting. Completing this code-along accelerated my understanding of using the React framework and implementing multiple functions onto the site."
            //   ghLink="https://github.com/ShivaniYadav07/TextUtils-REACT"
              // demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
